export default "__VITE_ASSET__84cfe11e__"